(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"));
	else if(typeof define === 'function' && define.amd)
		define(["react"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("react")) : factory(root["react"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(this, function(__WEBPACK_EXTERNAL_MODULE_0__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 1);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_0__;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(2);


/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_RadarChart__ = __webpack_require__(3);
/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__components_RadarChart__["a" /* default */]);

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__radar_css__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__radar_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__radar_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__radar__ = __webpack_require__(5);
var noSmoothing=function noSmoothing(points){var d='M'+points[0][0].toFixed(4)+','+points[0][1].toFixed(4);for(var i=1;i<points.length;i++){d+='L'+points[i][0].toFixed(4)+','+points[i][1].toFixed(4);}return d+'z';};var setViewBox=function setViewBox(options){return'-'+options.captionMargin+' 0 '+(options.size+options.captionMargin*2)+' '+options.size;};var defaultOptions={size:300,axes:true,// show axes?
scales:3,// show scale circles?
captions:true,// show captions?
dots:false,// show dots?
zoomDistance:1.2,// where on the axes are the captions?
smoothing:noSmoothing,// shape smoothing function
captionMargin:10,setViewBox:setViewBox,axisProps:function axisProps(){return{className:'axis'};},scaleProps:function scaleProps(){return{className:'scale',fill:'none'};},shapeProps:function shapeProps(){return{className:'shape'};},dotProps:function dotProps(){return{className:'dot'};},captionProps:function captionProps(){return{className:'caption',textAnchor:'middle',fontSize:10,fontFamily:'sans-serif'};}};var RadarChart=function RadarChart(props){var data=props.data,captions=props.captions,options=props.options,_props$size=props.size,size=_props$size===undefined?defaultOptions.size:_props$size,id=props.id;var chartOptions=Object.assign({},defaultOptions,options,{size:size});var setViewBox=chartOptions.setViewBox;var chart=Object(__WEBPACK_IMPORTED_MODULE_2__radar__["a" /* default */])(captions,data,chartOptions);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{version:'1',xmlns:'http://www.w3.org/2000/svg',width:size,height:size,viewBox:setViewBox(chartOptions),id:id},chart);};/* harmony default export */ __webpack_exports__["a"] = (RadarChart);

/***/ }),
/* 4 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var polarToX=function polarToX(angle,distance){return Math.cos(angle-Math.PI/2)*distance;};var polarToY=function polarToY(angle,distance){return Math.sin(angle-Math.PI/2)*distance;};var points=function points(_points){return _points.map(function(point){return point[0].toFixed(4)+','+point[1].toFixed(4);}).join(' ');};var axis=function axis(options){return function(col,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polyline',Object.assign({key:'poly-axis-'+i,points:points([[0,0],[polarToX(col.angle,options.chartSize/2),polarToY(col.angle,options.chartSize/2)]])},options.axisProps(col)));};};var dot=function dot(columns,options){return function(chartData,i){var data=chartData.data;var meta=chartData.meta||{};var extraProps=options.dotProps(meta);var mouseEnter=function mouseEnter(){};var mouseLeave=function mouseLeave(){};if(extraProps.mouseEnter){mouseEnter=extraProps.mouseEnter;}if(extraProps.mouseLeave){mouseLeave=extraProps.mouseLeave;}return columns.map(function(col){var val=data[col.key];if('number'!==typeof val){throw new Error('Data set '+i+' is invalid.');}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('circle',{key:'dot-'+col.key+'-'+val,cx:polarToX(col.angle,val*options.chartSize/2),cy:polarToY(col.angle,val*options.chartSize/2),className:[extraProps.className,meta.class].join(' '),onMouseEnter:function onMouseEnter(){return mouseEnter({key:col.key,value:val,idx:i});},onMouseLeave:function onMouseLeave(){return mouseLeave({});}});});};};var shape=function shape(columns,options){return function(chartData,i){var data=chartData.data;var meta=chartData.meta||{};var extraProps=options.shapeProps(meta);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',Object.assign({key:'shape-'+i,d:options.smoothing(columns.map(function(col){var val=data[col.key];if('number'!==typeof val){throw new Error('Data set '+i+' is invalid.');}return[polarToX(col.angle,val*options.chartSize/2),polarToY(col.angle,val*options.chartSize/2)];}))},extraProps,{stroke:meta.color,fill:meta.color,className:[extraProps.className,meta.class].join(' ')}));};};var scale=function scale(options,value){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('circle',Object.assign({key:'circle-'+value,cx:0,cy:0,r:value*options.chartSize/2},options.scaleProps(value)));};var caption=function caption(options){return function(col){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('text',Object.assign({key:'caption-of-'+col.key,x:polarToX(col.angle,options.size/2*0.95).toFixed(4),y:polarToY(col.angle,options.size/2*0.95).toFixed(4),dy:(options.captionProps(col).fontSize||10)/2},options.captionProps(col)),col.caption);};};var render=function render(captions,chartData){var options=arguments.length>2&&arguments[2]!==undefined?arguments[2]:{};if('object'!==(typeof captions==='undefined'?'undefined':_typeof(captions))||Array.isArray(captions)){throw new Error('caption must be an object');}if(!Array.isArray(chartData)){throw new Error('data must be an array');}options.chartSize=options.size/options.zoomDistance;var columns=Object.keys(captions).map(function(key,i,all){return{key:key,caption:captions[key],angle:Math.PI*2*i/all.length};});var groups=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{key:'g-groups}'},chartData.map(shape(columns,options)))];if(options.captions){groups.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{key:'poly-captions'},columns.map(caption(options))));}if(options.dots){groups.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{key:'g-dots'},chartData.map(dot(columns,options))));}if(options.axes){groups.unshift(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{key:'group-axes'},columns.map(axis(options))));}if(options.scales>0){var scales=[];for(var i=options.scales;i>0;i--){scales.push(scale(options,i/options.scales));}groups.unshift(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{key:'poly-scales'},scales));}var delta=(options.size/2).toFixed(4);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{transform:'translate('+delta+','+delta+')'},groups);};/* harmony default export */ __webpack_exports__["a"] = (render);

/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// index.js